import type { Props } from './Svg'
import { Svg } from './Svg'

export function Wind2Icon(props: Props) {
  return (
    <Svg width="48" height="48" {...props}>
      <path
        fill="currentColor"
        d="M24 47.1c-7.7 0-13.9-5.7-13.9-12.8 0-3 1.1-5.7 2.9-7.8H3.4A2.5 2.5 0 0 1 .9 24c0-7.7 5.7-13.9 12.8-13.9 3 0 5.7 1.1 7.8 2.9V3.4C21.5 2 22.6.9 24 .9c7.7 0 13.9 5.7 13.9 12.8 0 3-1.1 5.7-2.9 7.8h9.6c1.4 0 2.5 1.1 2.5 2.5 0 7.7-5.7 13.9-12.8 13.9a12 12 0 0 1-7.8-2.9v9.6c0 1.4-1.1 2.5-2.5 2.5Zm-2.5-20.3c-3.7.9-6.5 4-6.5 7.5s2.8 6.6 6.5 7.5v-15Zm5.3-.3c.9 3.8 4 6.5 7.5 6.5 3.6 0 6.6-2.8 7.5-6.5h-15Zm-20.6-5h15.1c-.9-3.8-4-6.5-7.5-6.5-3.7 0-6.7 2.8-7.6 6.5ZM26.5 6.2v15.1c3.8-.9 6.5-4 6.5-7.5s-2.8-6.7-6.5-7.6Z"
      />
    </Svg>
  )
}
